import {
	Component,
	Input,
	OnInit,
	forwardRef
} from '@angular/core';
import {
	ControlContainer,
	NgForm,
	NG_VALUE_ACCESSOR,
} from '@angular/forms';

import styles from './VbUiDurationInput.module.less';

import { MinuteMs } from 'rev-shared/date/Time.Constant';

import { BaseControlValueAccessor } from '../../util/BaseControlValueAccessor';

import moment from 'moment';

export interface IDurationModel {
	days: number,
	hours: number,
	minutes: number
}

let durationInputIndex = 0;

@Component({
	selector: 'vb-ui-duration-input',
	templateUrl: './VbUiDurationInput.Component.html',
	providers: [{
		provide: NG_VALUE_ACCESSOR,
		useExisting: forwardRef(() => VbUiDurationInputComponent),
		multi: true
	}],
	viewProviders: [{ provide: ControlContainer, useExisting: NgForm }],
	standalone: false
})
export class VbUiDurationInputComponent extends BaseControlValueAccessor<number> implements OnInit {
	@Input() public vbMin: number;
	@Input() public vbMax: number;
	@Input() public default: number;
	@Input() public asMinutes: boolean;
	@Input() public disabled: boolean;

	public readonly styles = styles;

	public internalModel: IDurationModel = {
		days: 0,
		hours: 0,
		minutes: 0
	};
	public days: number[];
	public hours: number[];
	public readonly minutes = [...Array(12).keys()].map(i => i * 5);
	public maxDaysSelected: boolean = false;
	public maxHoursSelected: boolean = false;
	public maxDays: number;
	public maxHours: number;
	public readonly durationInputIndex = `${++durationInputIndex}`;

	public ngOnInit(): void {
		const maxDuration = moment.duration(this.vbMax);
		this.maxDays = maxDuration.days();
		this.maxHours = maxDuration.hours();
		this.days = this.maxDays ? [...Array(this.maxDays + 1).keys()] : [];
		this.hours = this.maxHours ?
			this.hours = [...Array(this.maxHours + 1).keys()] :
			[...Array(24).keys()];
		if (this.default) {
			this.internalModel = this.toDurationModel(this.default);
		}
		this.updateInternalModelValue();
	}

	public writeValue(val: number): void {
		this.value = val;
		this.internalModel = this.toDurationModel(this.asMinutes ? val * MinuteMs : val);
	}

	protected updateInternalModelValue(): void {
		const duration = moment.duration(this.internalModel);
		this.updateModelValue(this.asMinutes ? duration.asMinutes() : duration.asMilliseconds());
	}

	public setModelDays(days: number): void {
		this.internalModel.days = days;
		if (days === this.maxDays && days !== 0) {
			this.maxDaysSelected = true;
			this.setModelHours(0);
			this.setModelMinutes(0);
		} else {
			this.maxDaysSelected = false;
		}
		this.updateInternalModelValue();
	}

	public setModelHours(hours: number): void {
		this.internalModel.hours = hours;
		if (hours === this.maxHours && hours !== 0) {
			this.maxHoursSelected = true;
			this.setModelMinutes(0);
		} else {
			this.maxHoursSelected = false;
		}
		this.updateInternalModelValue();
	}

	public setModelMinutes(minutes: number): void {
		this.internalModel.minutes = minutes;
		this.updateInternalModelValue();
	}

	private toDurationModel(durationMs: number): IDurationModel {
		const duration = moment.duration(durationMs);
		return {
			days: duration.days(),
			hours: duration.hours(),
			minutes: duration.minutes()
		};
	}
}
